<template lang="pug">
  .page
    layoutContainer
      .order-list(class="search-tab" v-if="enabled || isOperator")
        .options
          span 筛选
          el-select(v-model="orderType" placeholder="请选择" value-key="id")
            el-option(key="1" label="我的订单" value="1")
            el-option(key="2" label="我代销的订单" value="2" v-if="enabled")
            el-option(key="3" label="全站订单" value="3" v-if="isOperator")
        .options
          span 搜索
          el-select(v-model="queryType" placeholder="请选择" value-key="id" style="width: 180px;margin-right: 20px;")
            el-option(key="1" label="订单编号" value="1")
            el-option(key="2" label="所属人id" value="2" v-if="orderType === '3' || orderType === '2'")
            el-option(key="3" label="代销人id" value="3" v-if="orderType === '3' || orderType === '2'")
            el-option(key="4" label="代销单号" value="4" v-if="orderType === '3' || orderType === '2'")
            el-option(key="5" label="站外单号" value="5" v-if="orderType === '3'")
          el-input(v-model="queryContent" placeholder="输入关键字" style="width: 230px;")
          img.search-icon(src="/img/search-icon.png" @click="searchBtnClick")
      .order-list(v-for="item in list" :key="item.orderCode")
        .header
          span 订单号：{{item.orderCode}}
          span {{item.createTime}}
        .course-detail(v-for="(opt,j) in item.items" :key="j" @click="checkDetail(opt, item)" :style="{cursor: `${item.productBusiness === '知识' ? 'pointer' : ''}`}")
          span.name(:class="{'name-underline': item.productBusiness === '知识' || item.productBusiness === '咨询'}") {{ item.productBusiness === '会员' ? opt.productName : `产品名称：${opt.productName}`}}
          span.price ￥{{opt.totalPrice}}
        .course-detail(style="flex-direction: column; justify-content: flex-start;align-items: flex-start;" v-if="showOrderDetail(item)")
          .options-order-detail(v-if="(item.userName && (hasOrderType || isOperator)) || orderType === '2'")
            .label 所属用户ID
            .value {{item.userName}}
          .options-order-detail(v-if="item.agentSaleOrderId")
            .label 代销单号
            .value {{ item.agentSaleOrderId }}
          .options-order-detail(v-if="item.agentSaleUserName")
            .label 代销用户ID
            .value {{ item.agentSaleUserName }}
          .options-order-detail(v-if="item.outSideOrderId")
            .label 站外单号
            .value {{ item.outSideOrderId }}
          .options-order-detail(v-if="item.outSideOrderId")
            .label 站外订单号
            .value {{ item.outSiteOrderNumber }}
          .options-order-detail(v-if="item.belongPlatform")
            .label 推广渠道
            .value {{ item.belongPlatform }}
          .options-order-detail(v-if="item.promoteType")
            .label 推广方式
            .value {{ item.promoteType }}
          .options-order-detail(v-if="item.platformUserId")
            .label 主播平台号
            .value {{ item.platformUserId }}
          .options-order-detail(v-if="item.activityDeductPrice && item.activityDeductPrice !== '0.00'")
            .label 活动抵扣
            .value -￥{{ item.activityDeductPrice }}
          .options-order-detail(v-if="item.couponDeductPrice && item.couponDeductPrice !== '0.00'")
            .label 用券抵扣
            .value -￥{{ item.couponDeductPrice }}
          .options-order-detail(v-if="item.bargainDeductPrice && item.bargainDeductPrice !== '0.00'")
            .label 砍价抵扣
            .value -￥{{ item.bargainDeductPrice }}
          .options-order-detail(v-if="item.togetherBuyDeductPrice && item.togetherBuyDeductPrice !== '0.00'")
            .label 拼团抵扣
            .value -￥{{ item.togetherBuyDeductPrice }}
          .options-order-detail(v-if="item.promoteDeductPrice && item.promoteDeductPrice !== '0.00'")
            .label 推广抵扣
            .value -￥{{ item.promoteDeductPrice }}
        .btn-list
          span.reject-apply(v-if="item.togetherBuyStatus === 1") 拼团中
          span.reject-apply(v-if="item.togetherBuyStatus === 2") 拼团成功
          span.reject-apply(v-if="item.togetherBuyStatus === 3") 拼团失败
          //- 进程状态   展示类型   不可操作    线框
          //- 申请被拒绝/退款失败   红线框
          span.apply-reject(v-if="needApply(item) && item.refundApplyStatus === 2") 退款申请已拒绝
          span.reject-apply(v-if="needApply(item) && item.refundApplyStatus === 0") 退款申请处理中
          span.reject-apply(v-if="item.payTimeoutFlag") 支付超时
          span.reject-apply(v-if="item.refundStatus === 0") 退款中
          span.reject-apply(v-if="item.refundStatus === 1") 已退款
          span.apply-reject(v-if="item.refundStatus === 2") 退款失败
          span.reject-apply(v-if="item.refundStatus === 3") 已部分退款
          //- 可操作都是按钮
          //- 非视频 需要 申请退款
          .relation(v-if="(needApply(item) || !item.agentSaleOrderId) && (item.refundApplyFlag && (item.refundApplyStatus === null  ||item.refundStatus === 1)) && (item.refundApplyStatus !== 2 && item.refundStatus !== 1)" @click="refund(item, 1)") 申请退款
          //- 标准订单可  查看详细
          .relation(v-if="isStandard(item)" @click="goToClass(item)") 查看详细 {{ isStandard(item.productBusiness) }}
          //- 视频类订单 可以 去付款、退款
          .relation(v-if="isTechVideo(item) && item.refundFlag && item.refundStatus !== 1 && item.currentAgentSaleUserFlag === false" @click="refund(item)") 退款
          .relation(v-if="item.payFlag" @click="goPay(item)") 去付款
          //- 所有订单都可以  申请开票、联系客服
          .relation(v-if="item.invoiceApplyFlag" @click="applyInvoice(item)") 申请开票
          .relation(@click="relation") 联系客服
          el-popconfirm(v-if="item.outSideOrderId && item.refundFlag == true && item.refundStatus == null && item.productBusiness !== '咨询' " confirm-button-text='确定' cancel-button-text='取消' icon="el-icon-info" icon-color="red" title="确认置已退款么" @confirm="changeStatus(item, 1)" )
            .relation(slot="reference") 置已退款
          .relation(v-if="item.outSideOrderId && item.refundFlag == true && item.refundStatus == null && item.productBusiness === '咨询'" @click="changeStatus(item, 1)") 置已退款
          //el-popconfirm(confirm-button-text='确定' cancel-button-text='取消' icon="el-icon-info" icon-color="red" title="确认置已退款么" @confirm="changeStatus(item, 1)" )
          //  .relation(slot="reference") 置已退款
          //el-popconfirm(v-if="(item.agentSaleOrderId !== '') && item.agreeRefundFlag && item.refundApplyStatus !== 2 && item.refundStatus !== 1" confirm-button-text='确定' cancel-button-text='取消' icon="el-icon-info" icon-color="red" :title="`${item.productBusiness === '知识' ? '确定同意退款吗?' : '确认同意退款吗？（同意退款后将向客服发起退款申请）'}`" @confirm="changeStatus(item, 2)")
          //  .relation(slot="reference") 同意退款
          span.total_price 总额
            span.price(style="font-weight: bold !important;") ￥{{item.discountTotalPrice}}
      el-pagination(background layout="prev, pager, next" :total="total" @current-change="currentChange")
      el-dialog(:visible.sync="refundDialogVisible"  width="500px" center @close="closeRefundDialog")
        el-form(:model="refundFormData" ref="refRefundForm" :rules="refundFormRules" label-width="150px" )
          el-form-item(label="退款类型" prop="refundType")
            el-select(v-model="refundFormData.refundType" clearable placeholder="请选择退款类型" )
              el-option(v-for="option in refundTypeOptions" :key="option.value" :label="option.name" :value="option.value")
          el-form-item(v-if="refundFormData.refundType === 1" label="异常类型" prop="refundType")
            el-select(v-model="refundFormData.exceptionType" placeholder="请选择异常类型" )
              el-option(v-for="option in exceptionTypeOptions" :key="option.value" :label="option.name" :value="option.id")
          el-form-item(v-if="refundFormData.refundType === 1" label="原因描述" prop="refundReason")
            el-input(v-model="refundFormData.refundReason" type="textarea" resize="none" clearable placeholder="可不填" )
          el-form-item(label="退款金额" v-if="refundRatio")
            span(style="color: #FF724C;font-weight: bold;margin-right: 5px;") {{ refundAmount }}
            span 元{{ refundRatio }}
        div(style="text-align: center;")
          el-button(type="primary" @click="handleConsultingRefund")
            span(v-if="refundFormData.refundType === 1") {{ currentSelectedRow.outSideOrderId ? '申请更新可退款金额' : '申请退款'}}
            span(v-else) {{ currentSelectedRow.outSideOrderId ? '更新可退款金额' : '退款'}}
          div(style="color: #999999;margin-top: 10px;")
            span( style="cursor: pointer;" @click="handleViewRules") （查看退款规则）
      el-dialog(:visible.sync="externalRefundDialogVisible" width="500px" center @close="closeExternalRefundDialog")
        el-form(:model="externalRefundFormData" ref="refExternalRefundForm" label-width="auto" )
          el-form-item(label="退款类型" prop="refundType")
            el-input(v-model="externalRefundFormData.refundType" placeholder="请输入退款类型" maxlength="100" )
          el-form-item(label="退款金额" prop="refundAmount")
            el-input(v-model="externalRefundFormData.refundAmount" placeholder="请输入退款金额" maxlength="100" )
              span(slot="append") 元
          div(style="text-align: center;")
            el-button(type="primary" @click="handleExternalRefund") 置已退款
</template>

<script>
import {orderList, rejectedApply, passedApply, refund} from '@/api/subject'
import {refundApplication} from '@/api/product'
import {applyInvoice} from '@/api/background'
import {checkAuth} from '@/api/product'
import {
  consultRefund,
  consultRefundApply,
  getAgentSaleAuth,
  outSiteRefund,
  refundCheck,
  refundInfo
} from '../../api/orderAccount'

export default {
  name: 'pay',
  // components: {commonHeader},
  computed: {
    refundRatio() {
      if (this.refundFormData.refundType) {
        return (
          '（' + this.refundTypeOptions.find(item => item.value === this.refundFormData.refundType).refundRatio + '%）'
        )
      }
      return ''
    },
    refundAmount() {
      // 将百分比字符串转换为小数
      const value = parseFloat(this.refundTypeOptions.find(item => item.value === this.refundFormData.refundType).refundRatio) / 100;
      const returnValue = this.orderAmount * value
      // 计算乘积
      return returnValue.toFixed(2);
    }
  },
  data() {
    return {
      list: [],
      page: 1,
      total: 0,
      orderType: '1',
      queryType: '1',
      queryContent: '',
      hasOrderType: false,
      isOperator: false,
      enabled: false,
      isFirstInit: true,
      // 咨询类订单-退款-dialog-显示状态
      refundDialogVisible: false,
      // 咨询类订单-退款-dialog-表单数据
      refundFormData: {
        refundType: '',
        exceptionType: 2,
        refundReason: ''
      },
      refundFormRules: {
        refundType: [
          { required: true, message: '请选择退款类型', trigger: 'change'}
        ],
        exceptionType: [
          { required: true, message: '请选择异常类型', trigger: 'change'}
        ]
      },
      // 当前选中的订单信息
      currentSelectedRow: {},
      orderAmount: '',
      // 咨询类订单-退款-dialog-退款类型
      refundTypeOptions: [
        // {
        //   label: '服务异常申请退',
        //   value: 1
        // },
        // {
        //   label: '不满意退',
        //   value: 2
        // },
        // {
        //   label: '感觉没学到知识退',
        //   value: 3
        // },
        // {
        //   label: '感觉问题没解决退',
        //   value: 4
        // }
      ],
      filterRefundType: [],
      exceptionTypeOptions: [
        // {
        //   label: '信息作假',
        //   value: 1
        // },
        // {
        //   label: '态度恶劣',
        //   value: 2
        // },
        // {
        //   label: '诈骗',
        //   value: 3
        // },
        // {
        //   label: '违规（色情、暴力、涉政）',
        //   value: 4
        // },
        // {
        //   label: '其他',
        //   value: 5
        // }
      ],
      // 咨询-站外订单-退款dialog-显示状态
      externalRefundDialogVisible: false,
      // 咨询-站外订单-退款dialog-表单数据
      externalRefundFormData: {
        orderCode: '',
        refundType: '',
        refundAmount: ''
      }
    }
  },
  created() {
    this.orderType = this.$route.query.orderType !== undefined ? this.$route.query.orderType.toString() : '1'
    checkAuth({and: true, authList: [1]}).then(res => {
      this.isOperator = res.code === 200
    })
    this.$nextTick(() => {
      this.queryContent = this.$route.query.orderId || ''
      this.queryType = this.$route.query.queryType || ''
      this.hasOrderType = this.$route.query.orderType ? true : false
      this.isFirstInit = false
      this.getList()
      getAgentSaleAuth().then(res => {
        this.enabled = res.data.enabled === 1 ? true : false
      })
    })
  },
  watch: {
    orderType() {
      if (this.isFirstInit) return
      this.currentChange(1)
      this.queryType = ''
      this.queryContent = ''
    },
    $route(to, from) {
      if (to.query.appointmentId !== from.query.appointmentId) {
        this.getList()
      }
    }
    // queryContent() {
    //   this.currentChange(1)
    // }
  },
  methods: {
    showOrderDetail(item) {
      return (
        (item.userName && (this.orderType === '1' || this.hasOrderType) && this.isOperator) ||
        this.orderType === '2' ||
        item.agentSaleOrderId ||
        item.agentSaleUserName ||
        item.outSideOrderId ||
        item.belongPlatform ||
        item.promoteType ||
        item.platformUserId ||
        (item.activityDeductPrice && item.activityDeductPrice !== '0.00') ||
        (item.couponDeductPrice && item.couponDeductPrice !== '0.00') ||
        (item.bargainDeductPrice && item.bargainDeductPrice !== '0.00') ||
        (item.togetherBuyDeductPrice && item.togetherBuyDeductPrice !== '0.00') ||
        (item.promoteDeductPrice && item.promoteDeductPrice !== '0.00')
      )
    },
    searchBtnClick() {
      if (this.queryType === '') {
        this.$message.error('请选择搜索项')
        return
      }
      if (this.queryContent === '') {
        this.$message.error('请输入关键词')
        return
      }
      this.currentChange(1)
    },
    needApply(info) {
      return info.productBusiness === '会员' || info.productBusiness === '标准'
    },
    isStandard(info) {
      return info.productBusiness === '标准'
    },
    isTechVideo(info) {
      return info.productBusiness === '知识' || info.productBusiness === '咨询'
    },
    relation() {
      this.$router.push('/connectionQuanqing')
    },
    goToClass(info) {
      if (info.productBusiness === '会员') return
      if (info.productBusiness === '标准') {
        this.$router.push({
          path: '/quanqingStandard',
          query: {
            orderCode: info.orderCode
          }
        })
        return
      }
      this.$router.push({
        path: '/techVideoDetail',
        query: {id: info.productId}
      })
    },
    changeStatus(info, type) {
      console.log('%c [ info ]-194', 'font-size:13px; background:pink; color:#bf2c9f;', info)
      if (info.productBusiness === '咨询' && type === 1) {
        console.log('------- 点击 咨询 类 zhiyi退款 ')
        this.externalRefundDialogVisible = true
        this.externalRefundFormData.orderCode = info.orderCode
      } else {
        if (type === 1) {
          rejectedApply(info.orderCode).then(res => {
            if (res.code === 200) {
              this.$message.success('操作成功')
              this.getList()
              return
            }
            this.$message.error(res.msg)
          })
        } else {
          passedApply(info.orderCode).then(res => {
            if (res.code === 200) {
              this.$message.success('操作成功')
              this.getList()
              return
            }
            this.$message.error(res.msg)
          })
        }
      }
    },
    checkDetail(info, item) {
      if (item.productBusiness === '知识') this.$router.push(`/techVideoDetail?id=${info.productId}`)
      if (item.productBusiness === '咨询') this.$router.push(`/consultingRoom?appointmentId=${item.appointmentId}`)
    },
    refund(info, type) {
      this.currentSelectedRow = info
      if (info.productBusiness === '咨询') {
        console.log('------- 点击 咨询 类 退款 ', info)
        refundCheck({orderCode: info.orderCode}).then(res => {
          if (res.code === 200) {
            refundInfo({orderCode: info.orderCode}).then(res => {
              console.log('res= ', res)
              if (res.code === 200) {
                this.refundTypeOptions = res.data.refundTypes
                this.exceptionTypeOptions = res.data.exceptions
                this.orderAmount = res.data.orderAmount
                this.refundDialogVisible = true
                this.refundFormData.orderCode = info.orderCode
              }
            })
          } else {
            this.$message.warning(res.msg)
          }
        })
      } else {
        let toastMsg = ''
        if (info.productBusiness === '会员') {
          toastMsg = '申请审核0-2天通过后，预计0-7天内退款成功，并收回对应会员时长。确定申请退款吗？'
        } else if (info.productBusiness === '标准') {
          toastMsg = '退款申请将在0-2天内由客服审核，审核通过后才可退款。确定申请退款吗？'
        } else {
          toastMsg = '确认要退款吗？'
        }
        if (info.agentSaleOrderId !== '') {
          if (info.productBusiness === '会员') {
            toastMsg =
              '代销订单在申请审核0-2天通过后，是即时退款到您的账户，您再自行提现即可。退款成功后会收回对应会员时长。确定申请退款吗？'
          } else if (info.productBusiness === '标准') {
            toastMsg =
              '退款申请将在0-2天内由客服审核，审核通过后才可退款。并且审核通过后，代销订单是退款到您的账户，您再自行提现即可。确定申请退款吗？'
          } else {
            toastMsg = '代销订单是退款到您的账户，您再自行提现即可。确定退款吗？'
          }
        }
        this.$confirm(toastMsg)
          .then(() => {
            if (info.productBusiness === '会员' || info.productBusiness === '标准') {
              refundApplication({
                orderCode: info.orderCode
              }).then(res => {
                if (res.code === 200) {
                  this.$dialog.toast(info.agentSaleOrderId ? '已成功提交退款申请' : '退款申请已提交', {
                    delay: 4
                  })
                  this.getList()
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              refund(info.orderCode).then(res => {
                if (res.code === 200) {
                  this.$dialog.toast('退款申请已提交', {delay: 4})
                  this.getList()
                } else {
                  this.$message.error(res.msg)
                }
              })
            }
          })
          .catch(() => {})
      }
    },
    // 咨询类退款-dialog-关闭事件
    closeRefundDialog() {
      this.refundDialogVisible = false
      this.refundFormData = {
        refundType: '',
        exceptionType: 2,
        refundReason: ''
      }
    },
    // 咨询类退款-dialog-退款/申请退款
    handleConsultingRefund() {
      this.$refs.refRefundForm.validate(valid=>{
        if(valid) {
          if (this.refundFormData.refundType === 1) {
            // 按钮-申请退款
            let text =
              '退款率过高预约别人时可能会被拒绝；另外，服务异常申请退，需要客服回看您与对方的交流过程视频，核实无误后才会为您退款。' +
              (this.currentSelectedRow.couponDeductPrice ? '退款后代金券不会退。' : '') +
              '确定申请退款吗？'
            if (this.currentSelectedRow.agentSaleOrderId) {
              // 代销单
              text =
                '退款率过高预约别人时可能会被拒绝；另外，服务异常申请退，需要客服回看您与对方的交流过程视频，核实无误后才会为您退款。另外，代销订单是退款到您的账户，您再自行提现即可。' +
                (this.currentSelectedRow.couponDeductPrice ? '退款后代金券不会退。' : '') +
                '确定申请退款吗？'
            } else if (this.currentSelectedRow.outSideOrderId) {
              // 站外单
              text =
                '退款率过高预约别人时可能会被拒绝；另外，服务异常申请退，需要客服回看您与对方的交流过程视频，核实无误后才会为您通过申请。另外站外订单点击这里只会生成可退款金额的数据，具体退款需要您到站外下单的平台（比如抖音）操作退款。' +
                (this.currentSelectedRow.couponDeductPrice ? '退款后代金券不会退。' : '') +
                '确定申请吗？'
            }
            this.$confirm(text).then(() => {
              consultRefundApply(this.refundFormData).then(res => {
                if (res.code === 200) {
                  this.$message.success('已提交退款申请')
                  this.closeRefundDialog()
                }else{
                  this.$message.warning(res.msg)
                }
              })
            })
          } else {
            // 按钮-退款
            let text =
              '退款率过高预约别人时可能会被拒绝。' +
              (this.currentSelectedRow.couponDeductPrice ? '退款后代金券不会退。' : '') +
              '确定退款吗？'
            if (this.currentSelectedRow.agentSaleOrderId) {
              // 代销单
              text =
                '退款率过高预约别人时可能会被拒绝。另外代销订单是退款到您的账户，您再自行提现即可。' +
                (this.currentSelectedRow.couponDeductPrice ? '退款后代金券不会退。' : '') +
                '确定退款吗？'
            } else if (this.currentSelectedRow.outSideOrderId) {
              // 站外单
              text =
                '退款率过高预约别人时可能会被拒绝。另外站外订单点击这里只会生成可退款金额的数据，具体退款需要您到站外下单的平台（比如抖音）操作退款。' +
                (this.currentSelectedRow.couponDeductPrice ? '退款后代金券不会退。' : '') +
                '确定吗？'
            }
            this.refundFormData.exceptionType = undefined
            this.refundFormData.refundReason = undefined
            this.$confirm(text).then(() => {
              consultRefund(this.refundFormData).then(res => {
                if (res.code === 200) {
                  this.$message.success('操作成功')
                  this.closeRefundDialog()
                }
              })
            })
          }
        }
      })
    },
    // 咨询类退款-dialog-查看退款规则
    handleViewRules() {
      const routeData = this.$router.resolve({
        path: '/faq?tag=咨询'
      })
      window.open(routeData.href, '_blank')
    },
    // 咨询类-站外订单-置已退款dialog-确定
    handleExternalRefund() {
      if (!this.externalRefundFormData.refundType) {
        this.$message.warning('请输入退款类型')
        return
      }
      if (!this.externalRefundFormData.refundAmount) {
        this.$message.warning('请输入退款金额')
        return
      }
      if (
        this.externalRefundFormData.refundAmount &&
        Number(this.externalRefundFormData.refundAmount) < 0 &&
        Number(this.externalRefundFormData.refundAmount) > 10000
      ) {
        this.$message.warning('退款金额大于0或小于10000')
      }
      outSiteRefund(this.externalRefundFormData)
        .then(res => {
          if (res.code === 200) {
            this.$message('操作成功')
            this.getList()
            this.closeExternalRefundDialog()
          } else {
            this.$message.warning(res.msg)
          }
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    // 咨询类-站外订单-置已退款dialog-关闭事件
    closeExternalRefundDialog() {
      this.externalRefundDialogVisible = false
      this.externalRefundFormData = {
        orderCode: '',
        refundType: '',
        refundAmount: ''
      }
    },
    applyInvoice(info) {
      this.$confirm('是否申请开发票？').then(() => {
        applyInvoice({orderCode: info.orderCode}).then(res => {
          if (res.code === 200) {
            this.$dialog.toast('您的开票申请在等待客服处理中，请耐心等待')
            this.getList()
          }
        })
      })
    },
    currentChange(val) {
      this.page = val
      this.getList()
    },
    getList() {
      orderList({
        pageNum: this.page,
        pageSize: 10,
        orderType: this.orderType,
        queryType: this.queryType,
        queryContent: this.queryContent,
        appointmentId: this.$route.query.appointmentId || undefined
      }).then(res => {
        this.list = res.data.records
        this.total = res.data.total
      })
    },
    goPay(item) {
      this.$router.push({
        path: '/pay',
        query: {
          courseId: item.productId,
          orderId: item.orderCode
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  min-height: 100%;
  .search-tab {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px !important;
    .options {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      span {
        margin-right: 20px;
      }
    }
  }
  .order-list {
    max-width: 1200px;
    min-width: 960px;
    padding: 0 30px;
    background: #ffffff;
    border-radius: 8px;
    margin: 20px auto;
  }
  .header {
    height: 107px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #666666;
      line-height: 37px;
    }
  }
  .btn-list {
    padding: 30px 0 50px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    span {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: red;
      line-height: 40px;
      margin-left: 5px;
    }
    .refund-agreement {
      font-size: 20px;
      font-weight: 400;
      cursor: pointer;
      color: #5ad3cd;
      line-height: 40px;
      text-decoration: underline;
    }
    .apply-reject {
      padding-left: 20px;
      padding-right: 20px;
      line-height: 38px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #ff724c;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ff724c;
      text-align: center;
    }
    .reject-apply {
      padding-left: 20px;
      padding-right: 20px;
      height: 40px;
      line-height: 38px;
      border-radius: 20px;
      border: 1px solid #d3d3d3;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #666666;
      text-align: center;
    }
    .refund-way {
      width: 100px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #d3d3d3;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #666666;
      text-align: center;
    }
    .apply-refund {
      width: 100px;
      height: 40px;
      background: #ff724c;
      border-radius: 20px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
    }

    .refund {
      width: 100px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #979797;
      font-size: 18px;
      font-weight: 500;
      color: #666666;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      margin-left: 10px;
    }
    .go-pay {
      width: 100px;
      height: 40px;
      border-radius: 20px;
      background: #ff724c;
      border-radius: 20px;
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      margin-left: 10px;
      cursor: pointer;
    }
    .relation {
      width: 100px;
      height: 40px;
      border-radius: 20px;
      background: #5ad3cd;
      border-radius: 20px;
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      margin-left: 10px;
      cursor: pointer;
    }
  }
  .course-detail {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgba(239, 239, 239, 0.5);
    border-radius: 8px;
    padding: 30px;
    .name {
      //width: 1000px;
      font-size: 24px;
      line-height: 33px;
      margin-right: 40px;
      overflow: hidden;
    }
    .name-underline{
      cursor: pointer;
      border-bottom: 1px solid #333333;
    }
    span {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 400;
      color: #333333;
    }

    .price {
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ff724c;
    }
  }
}
.options-order-detail {
  height: 40px;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  display: flex;
  .label {
    width: 100px;
    color: #acacac;
    margin-right: 20px;
  }
}
.total_price {
  padding-left: 15px;
  font-size: 24px !important;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 400 !important;
  color: #666666 !important;
  .price {
    font-size: 30px !important;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500 !important;
    color: #ff724c !important;
  }
}
.search-icon {
  width: 32px;
  height: 32px;
  cursor: pointer;
  margin-left: 20px;
}
.el-dialog {
  overflow: hidden;
}
</style>
